var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.845 32.7092C13.2956 21.7252 21.7252 13.2956 32.7092 11.845C40.2604 10.8477 49.7064 10 60 10C70.2936 10 79.7396 10.8477 87.2908 11.845C98.2748 13.2956 106.704 21.7252 108.155 32.7092C109.152 40.2604 110 49.7064 110 60C110 70.2936 109.152 79.7396 108.155 87.2908C106.704 98.2748 98.2748 106.704 87.2908 108.155C79.7396 109.152 70.2936 110 60 110C49.7064 110 40.2604 109.152 32.7092 108.155C21.7252 106.704 13.2956 98.2748 11.845 87.2908C10.8477 79.7396 10 70.2936 10 60C10 49.7064 10.8477 40.2604 11.845 32.7092Z",
    fill: "#1FBF79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9522 36.4682C84.3829 34.7149 86.9073 34.5016 88.5905 35.992C90.2737 37.4824 90.4784 40.1119 89.0477 41.8653L55.0477 83.5318C53.5945 85.3127 51.0196 85.5003 49.3425 83.9475L31.3426 67.2809C29.6915 65.752 29.5427 63.1184 31.0104 61.3985C32.4781 59.6786 35.0064 59.5236 36.6575 61.0525L51.6009 74.8889L82.9522 36.4682Z",
    fill: "#1FBF79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/Icon_success.14b48de5289cedd5f57adacecc1474af.svg";
export { ForwardRef as ReactComponent };